<template>
    <div class="wrap">
        <div class="font-2">
            Create an A/B test
        </div>
        <div class="font-7 header">
            Select 1 of the following formats to compare different monetization strategies through A/B testing.
        </div>
        <CreationOption :iconHeight="24"
                        :iconWidth="50"
                        iconName="quickABColorIcon"
                        title="Quick A/B Test"
                        id="createQuickTest"
                        @createTestClick="showStartQuickTestModal"
                        class="option"
        >
            <template v-slot:description>
                <div>
                    Automatically split your traffic 50/50,
                    then modify each group's waterfall <br> with no additional setup required.
                    <a :href="links.quickABTest" target="_blank"> Learn more</a>
                </div>
            </template>
        </CreationOption>
        <CreationOption :iconHeight="24"
                        :iconWidth="50"
                        iconName="quickABColorIcon"
                        title="Quick Bidding Test"
                        id="createBiddingTest"
                        @createTestClick="$emit('createTestClick', testTypeBidding)"
                        class="option"
        >
            <template v-slot:description>
                <div>
                    Quickly compare the performance of a
                    <span class="font-6">traditional waterfall vs. a hybrid waterfall</span><br>
                    that includes in-app bidding.
                    <a :href="links.biddingTest" target="_blank"> Learn more</a>
                </div>
            </template>
            <template v-slot:postTitle>
                <IconBase height="18" width="70" iconName="levelPlayNetworkIcon" class="level-play"/>
            </template>
        </CreationOption>
        <CreationOption :iconHeight="23"
                        :iconWidth="45"
                        iconName="abColorIcon"
                        title="A/B Test"
                        id="createABTest"
                        :isDisabled="hasMissingConfigs"
                        @createTestClick="$emit('createTestClick', testTypeAB)"
                        class="option"
        >
            <template v-slot:description>
                <div>
                    Define your traffic split and run 2 custom app
                    <span class="font-6">configurations</span>
                    simultaneously.
                    <a :href="links.abTesting" target="_blank"> Learn more</a>
                </div>
            </template>
        </CreationOption>
    </div>
</template>

<script>
import Vue from 'vue';
import IconBase from 'components/IconBase.vue';
import links from 'services/metaData/links';
import CreationOption from './CreationOption.vue';
import { testTypeAB, testTypeBidding, testTypeQuick } from './consts';

export default {
    name: 'CreateTest',
    components: { IconBase, CreationOption },
    props: {
        appIcon: {
            type: String
        },
        platform: {
            type: String
        },
        appName: {
            type: String
        },
        appKey: {
            type: String
        },
        hasMissingConfigs: {
            type: Boolean
        }
    },
    data() {
        return {
            testTypeAB,
            testTypeBidding,
            links
        };
    },
    methods: {
        showStartQuickTestModal() {
            Vue.prototype.$modal.openStartQuickABModal({
                props: {
                    appIcon: this.appIcon,
                    platform: this.platform,
                    appName: this.appName,
                    appKey: this.appKey
                },
                version: 1,
                clickOutsideClose: false,
                okButtonText: 'Start Test',
                onOK: () => {
                    this.$emit('createTestClick', testTypeQuick);
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";
@import "~styles/buttons";

.wrap {
    color: $light-800;
}

.header {
    margin-bottom: 25px;
    margin-top: 10px;
}

.level-play {
    height: 18px;
    vertical-align: middle;
    margin-left: 5px;
}

.option {
    margin-bottom: 15px;
}
</style>
